// Environment configuration
import { AppConfig } from '../typings/auth';

// Configuration from environment variables
export const ENV_CONFIG: AppConfig = {
  clientId: process.env.REACT_APP_APS_CLIENT_ID || '',
  environment: (process.env.REACT_APP_ENV as 'dev' | 'int' | 'stg' | 'prod') || 'dev',
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '',
  processSettingEndpoint: process.env.REACT_APP_PROCESS_SETTING_ENDPOINT || '',
  authUserEndpoint: process.env.REACT_APP_AUTH_USER_ENDPOINT || ''
};



// Helper function to update config with current redirect URI
export const getUpdatedConfig = (): AppConfig => ({
  ...ENV_CONFIG
});

// Helper function to get the full API URL for process setting endpoint
export const getProcessSettingApiUrl = (): string => {
  return `${ENV_CONFIG.apiBaseUrl}${ENV_CONFIG.processSettingEndpoint}`;
};

// Helper function to get the full API URL for auth user endpoint
export const getAuthUserEndpoint = (): string => {
  return `${ENV_CONFIG.apiBaseUrl}${ENV_CONFIG.authUserEndpoint}`;
};